























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { startOfMonth, endOfMonth } from "date-fns";
import { Circle2 } from "vue-loading-spinner";

import EspressoAux from "@/components/Espresso/EspressoAux.vue"
import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import FormField from "@/layouts/DashboardLayoutComponents/FormField.vue";
import ShiftFilter from "@/layouts/DashboardLayoutComponents/ShiftFilter.vue";
import ModalTabs from "@/layouts/DashboardLayoutComponents/ModalTabs.vue";

import shiftModel from "@/models/shift.model";
import bankingFileModel from '@/models/bankingFile.model';
import inhouseProfessionalModel from '@/models/inhouseProfessional.model';
import inhouseProfessionalPayrollModel from '@/models/inhouseProfessionalPayroll.model';
import bankingAccountModel from '@/models/bankingAccount.model';
import { showExpandableToast } from '@/utils/error';

function getMonthName(month: number) {
	// get name
	const monthName = new Date(2020, month, 1).toLocaleString('pt-BR', { month: 'long' });
	// capitalize first letter
  return monthName.charAt(0).toUpperCase() + monthName.slice(1);
}

@Component({
	components: {
		PaginatedSearch,
		FormField,
		ShiftFilter,
		Circle2,
		ModalTabs,
	},
})
export default class Payroll extends Vue {
	shiftModel: any;
	inhouseProfessionalModel: any;
	inhouseProfessionalPayrollModel: any;
	bankingAccountsOptions: any[] = [];

	constructor() {
		super();
		this.inhouseProfessionalModel = inhouseProfessionalModel;
		this.inhouseProfessionalPayrollModel = inhouseProfessionalPayrollModel;
	}

	async beforeMount() {
		const inhouseProfessionalSchema = await inhouseProfessionalModel.getDescription();
		// load employment relationship options
		const employmentRelationshipField = { ...inhouseProfessionalSchema.find((field: any) => field.key === "employmentRelationship") };
		employmentRelationshipField.options = [{ name: "Todos", value: null }, ...employmentRelationshipField.options];
		this.inhouseFilterSchema.push(employmentRelationshipField);
		// load position options
		const positionField = { ...inhouseProfessionalSchema.find((field: any) => field.key === "position") };
		positionField.options = [{ name: "Todos", value: null }, ...positionField.options];
		this.inhouseFilterSchema.push(positionField);
		const bankingAccounts = await bankingAccountModel.getBankingAccounts();
		this.bankingAccountsOptions = bankingAccounts.map(account => {
			return {
				name: `${account.name} c/c ${account.accountNumber}-${account.accountDigit}`,
				value: account.id,
			}
		});
	}

	// Inhouse payroll
	inhousePayroll = [];

	inhouseFilterSchema: any[] = [
		{ name: "Mês", key: "month", kind: "select", options: [...Array(12).keys()].map(month => ({ value: month + 1, name: getMonthName(month) })) },
		{ name: "Ano", key: "year", kind: "select", options: [...Array(10).keys()].map(delta => 2018 + delta).map(year => ({ value: year, name: year })) },
		{ name: "Profissional", key: "inhouseProfessional", kind: "relation", relationType: "many-to-one" },
	];

	selectedBankingAccount = null;
	paymentMode: 'GROSS' | 'NET' = 'GROSS';

	inhouseFilterEntity: any = {
		month: new Date().getMonth() + 1,
		year: new Date().getFullYear(),
		employmentRelationship: null,
		position: null,
		"inhouseProfessional.id": null,
	};

	get inhouseProfessionalFilter() {
		const filter: any = {};
		if (this.inhouseFilterEntity.employmentRelationship) {
			filter.employmentRelationship = this.inhouseFilterEntity.employmentRelationship;
		}
		if (this.inhouseFilterEntity.position) {
			filter.position = this.inhouseFilterEntity.position;
		}
		return filter;
	}

	get inhousePayrollFilter() {
		return {
			month: this.inhouseFilterEntity.month || undefined,
			year: this.inhouseFilterEntity.year || undefined,
			"inhouseProfessional.employmentRelationship": this.inhouseFilterEntity.employmentRelationship || undefined,
			"inhouseProfessional.position": this.inhouseFilterEntity.position || undefined,
			inhouseProfessional: this.inhouseFilterEntity["inhouseProfessional.id"] || undefined,
		};
	}

	generatingPayroll = false;
	async generateInhousePayroll() {
		const { month, year } = this.inhouseFilterEntity;
		this.generatingPayroll = true;
		try {
			await inhouseProfessionalPayrollModel.generatePayroll(month, year);
			this.$toasted.success(`Gerada folha de pagamento para o mês ${month}/${year}`);
			(this.$refs.inhousePayrollSearch as any).refresh();
		} catch (error) {
			this.$toasted.error("Não foi possível gerar a folha");
			console.error(error);
		}
		this.generatingPayroll = false;
	}

	async generateInhousePayrollBankingFile() {
		if (!this.selectedBankingAccount) {
			this.$toasted.error("Selecione uma conta bancária!");
			return;
		}

		for (const payrollEntry of this.selectedInhousePayrollEntries) {
			if (payrollEntry.status !== 'PENDING') {
				this.$toasted.error("Não é possível gerar arquivos bancários para pagamentos já faturados");
				return;
			}
		}
		this.bankingFileLoading = true;
		try {
			const cnabInfo = await inhouseProfessionalPayrollModel.generateBankingFile(this.selectedInhousePayrollEntries.map((payrollEntry: any) => payrollEntry.id), (this.selectedBankingAccount as any));
			bankingFileModel.downloadCnab(cnabInfo);
			(this.$refs.inhousePayrollSearch as any).refresh();
		} catch (error) {
			console.error(error);
			showExpandableToast(this.$toasted, error, "Erro ao gerar arquivo bancário. Tente novamente.");
		}
		this.bankingFileLoading = false;
	}

	selectedInhousePayrollEntries: any[] = [];
	inhousePayrollEntrySelected(payrollEntries: any) {
		this.selectedInhousePayrollEntries = payrollEntries;
	}

	// Shifts payroll
	payroll: any = [];
	payrollFilter: any;
	loading = false;

	async updateFilter(filter: any) {
		this.selectedProfessionalUserIds = [];
		this.payrollFilter = filter;
		this.loading = true;
		try {
			this.payroll = await shiftModel.getPayroll(filter);
		} catch (error) {
			console.error(error);
			this.$toasted.error("Erro ao carregar. Verifique sua conexão com a Internet.");
		}
		this.loading = false;
	}

	showShifts = false;
	shifts: any = [];
	shiftsLoading: boolean = false;

	async loadShifts(payrollRow: any) {
		this.showShifts = true;
		this.shiftsLoading = true;
		try {
			this.shifts = await shiftModel.getPayroll({ ...this.payrollFilter, professionalUser: payrollRow.professionalUserId, detailed: true });
		} catch (error) {
			console.error(error);
			this.$toasted.error("Erro ao carregar plantões. Tente novamente.");
		}
		this.shiftsLoading = false;
	}

	bankingFileLoading = false;
	async generateBankingFile() {
		if (!this.selectedBankingAccount) {
			this.$toasted.error("Selecione uma conta bancária!");
			return;
		}

		this.bankingFileLoading = true;
		try {
			const cnabInfo = await shiftModel.generateBankingFile(this.payrollFilter, this.selectedProfessionalUserIds, (this.selectedBankingAccount as any), this.paymentMode);
			bankingFileModel.downloadCnab(cnabInfo);
			await this.updateFilter(this.payrollFilter);
		} catch (error) {
			console.error(error);
			showExpandableToast(this.$toasted, error, "Erro ao gerar arquivo bancário. Tente novamente.");
		}
		this.bankingFileLoading = false;
	}

	selectedProfessionalUserIds: number[] = [];
	rowSelected(payrollItems: any) {
		this.selectedProfessionalUserIds = payrollItems.map((payrollItem: any) => payrollItem.professionalUserId);
	}
}
